module.exports = __webpack_public_path__ + "static/media/homepagebg.8883f867.png";